module.exports = __webpack_public_path__ + "static/media/7-q.b5f7772d.mp3";